import {
    AwesomeTableComponent,
    IColumnsProps,
    Icon,
    useDeepEffect,
    ViewTextError,
} from "d-react-components";
import { filter, find, map } from "lodash";
import { useMemo } from "react";
import InventoryAPI from "../../../../api/queries/inventory";
import InputTextQuantity from "../../../../common/input/InputTextQuantity";
import { IEquipment } from "../../../../interfaces/equipment";
import Messages from "../../../../languages/Messages";
import EquipmentNameView from "../../../equipment/share/EquipmentNameView";
import EquipmentSearchButton from "../../../equipment/share/EquipmentSearchButton";

const EquipmentStockAdjustmentCreateItems = ({ stockAdjustmentForm }: any) => {
    const { values, errors, setFieldValue } = stockAdjustmentForm || {};
    const { equipments, branch } = values || {};
    const equipmentIds = useMemo(() => {
        return map(equipments || [], (i) => i?.id);
    }, [equipments]);

    useDeepEffect(() => {
        if (equipmentIds && equipmentIds?.length > 0 && branch?.id) {
            // mapStockToEquipment();
        }
    }, [equipmentIds]);

    const columns: IColumnsProps = [
        {
            title: Messages.item,
            dataIndex: "",
            render: (equipment) => <EquipmentNameView equipment={equipment} />,
        },
        {
            title: Messages.currentQty,
            dataIndex: "currentQty",
        },
        {
            title: Messages.quantity,
            dataIndex: "quantity",
            render: (quantity, item) => (
                <InputTextQuantity
                    min={0}
                    max={1}
                    useParseInt={false}
                    value={quantity}
                    onChange={(quantityValue) =>
                        onUpdateQty({
                            ...item,
                            quantity: quantityValue,
                        })
                    }
                />
            ),
        },
        {
            title: Messages.action,
            dataIndex: "",
            render: (service) => (
                <Icon
                    className="cursor-pointer"
                    name="remove_circle_outline"
                    onClick={() => onRemoveEquipment([service?.id])}
                />
            ),
        },
    ];

    const mapStockToEquipment = async () => {
        try {
            const res = await InventoryAPI.checkProductStock({
                branch: [branch?.id],
                product: equipmentIds,
            });
            const proStocks = res?.data?.data?.data ?? [];
            const mappedStocks = map(equipments, (item) => {
                const found = find(proStocks, (pro) => pro?.id === item?.id);
                return {
                    ...item,
                    currentQty: found?.quantity ?? 0,
                    quantity: item?.quantity ?? found?.quantity ?? 0,
                };
            });
            setFieldValue("equipments", mappedStocks);
        } catch (error) {
            console.error({ error });
        }
    };

    const onAddEquipment = (addPros: IEquipment[]) => {
        setFieldValue("equipments", addPros);
    };

    const onRemoveEquipment = (removeIds: string[]) => {
        setFieldValue(
            "equipments",
            filter(equipments, (pro) => !removeIds?.includes(pro?.id))
        );
    };

    const onUpdateQty = (updatePro: any) => {
        setFieldValue(
            "equipments",
            map(equipments, (pro) =>
                updatePro?.id === pro?.id ? updatePro : pro
            )
        );
    };

    return (
        <div className="mt-3">
            <div className="flex-row-between-center">
                <label>{Messages.items}</label>
                {values?.branch && (
                    <EquipmentSearchButton
                        onSave={onAddEquipment}
                        defaultValue={equipments ?? []}
                        // filterSource={{
                        //     productType: [PRODUCT_TYPE.SIMPLE_PRODUCT],
                        // }}
                    >
                        {Messages.add}
                    </EquipmentSearchButton>
                )}
            </div>
            <AwesomeTableComponent
                columns={columns}
                dataSource={equipments ?? []}
                className="mt-3"
                pagination={false}
            />
            {errors?.equipments && <ViewTextError error={errors.equipments} />}
        </div>
    );
};

export default EquipmentStockAdjustmentCreateItems;
